import React from 'react'
import {ReactComponent as DownloadIcon} from "../../assets/images/CommonComponent/downloads.svg"
import './Button.scss'
import { CircularProgress } from '@mui/material'

function DownloadButton({loading, text, onClick, type='button', disabled=false}) {
  return (
    <button className="custom-button text-white text-nowrap p-2 px-3 d-flex justify-content-between align-items-center mx-1" disabled={disabled} type={type} onClick={onClick} style={{
        backgroundColor: '#74613C',
    }}>
        <span className="btn-icon">
            {
                !loading ?
                <>
                    <DownloadIcon fontSize={'17px'} className='mr-1' /> 
                </>
                :
                <CircularProgress size={13} className='mt-1 mr-1' sx={{color: 'white'}} />
            }
        </span>
        {text}
    </button>
  )
}

export default DownloadButton
